/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Swal_CancelInputs */



/**
* | output |
* | --- |
* | "Use Original Timing" |
*
* @param {Paste_Swal_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_swal_cancel = /** @type {((inputs?: Paste_Swal_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Swal_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser le Minutage d'Origine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Originale Zündung verwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa la temporizzazione originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использовать исходное время")
	if (locale === "es") return /** @type {LocalizedString} */ ("Utilice la sincronización original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用原时序")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナルのタイミングを使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल समय का उपयोग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Use a sincronização original")
	return /** @type {LocalizedString} */ ("Use Original Timing")
});